import { useProductContext } from '../product-router';
import { useGenericFilters } from './filter-context';
import { SITE_FILTER_TYPE_NAME, DEFAULT_OPTION } from './filter-types';
export var useCurrentProductHasFilters = function useCurrentProductHasFilters() {
  var _filterDefinitions$pr;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var product = getActiveProduct();
  var _useGenericFilters = useGenericFilters(),
    filterDefinitions = _useGenericFilters.filterDefinitions;
  return !!(product && ((_filterDefinitions$pr = filterDefinitions[product.id]) === null || _filterDefinitions$pr === void 0 ? void 0 : _filterDefinitions$pr.length) > 0);
};
export var useGetCurrentProductFilters = function useGetCurrentProductFilters() {
  var _useProductContext2 = useProductContext(),
    getActiveProduct = _useProductContext2.getActiveProduct;
  var product = getActiveProduct();
  var _useGenericFilters2 = useGenericFilters(),
    filterDefinitions = _useGenericFilters2.filterDefinitions;
  return product && filterDefinitions[product.id] || [];
};
export var useCurrentProductHasAppliedFilters = function useCurrentProductHasAppliedFilters() {
  var filters = useGetCurrentProductFilters();
  var hasFilters = false;
  filters.forEach(function (filter) {
    filter.store.availableFilters.forEach(function (option) {
      if (option.isChecked && option.id !== DEFAULT_OPTION) {
        hasFilters = true;
      }
    });
  });
  return hasFilters;
};
export var useCurrentProductGenericSelectedFilterCount = function useCurrentProductGenericSelectedFilterCount() {
  var filters = useGetCurrentProductFilters();
  var genericFilters = filters.filter(function (filter) {
    return filter['@type'] !== SITE_FILTER_TYPE_NAME;
  });
  return genericFilters.reduce(function (filterCount, nextFilter) {
    return nextFilter.store.availableFilters.filter(function (f) {
      return f.isChecked;
    }).length + filterCount;
  }, 0);
};